import React from "react";
import Index from "./index";
import EmployeeTable from "./EmployeeTable";

const Employees = () => {
  const { allEmployees, loading, history, search, setSearch } = Index();
  return (
    <EmployeeTable
      allEmployees={allEmployees}
      loading={loading}
      history={history}
      search={search}
      setSearch={setSearch}
    />
  );
};

const comparisonFn = function (prevProps, nextProps) {
  return (
    prevProps.location.pathname === nextProps.location.pathname &&
    prevProps.colorMode === nextProps.colorMode
  );
};
export default React.memo(Employees, comparisonFn);
